<template>
  <chat-widget></chat-widget>
</template>

<script>
import ChatWidget from "./components/ChatWidget.vue";

export default {
  name: "App",
  components: { ChatWidget },
};
</script>

<style></style>
